import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import classes from './TimeandExpensePopup.module.scss';
import MainButton from '../../buttons/MainButton';
import colors from '../../../../scss/colors';

export default function TimeandExpensePopup({
  title,
  primaryButton = {
    text: '',
    action: ''
  },
  secondaryButton = {
    text: '',
    action: ''
  },
  pending = false
}) {
  return (
    <div className={classes.popupContainer}>
      <p className={classes.popupLabel}>{title}</p>
      {primaryButton.text.length ? (
        <MainButton rounded forceWidth="244px" action={primaryButton.action}>
          {pending ? <CircularProgress size={20} sx={{ color: colors.WHITE }} /> : primaryButton.text}
        </MainButton>
      ) : null}
      {secondaryButton.text.length ? (
        <MainButton rounded outlined forceWidth="244px" action={secondaryButton.action}>
          {secondaryButton.text}
        </MainButton>
      ) : null}
    </div>
  );
}
